import { get,  post, patch, destroy } from 'api/bdex_api'

export const apiLoadAllPrintRequests = (authAxios, controls) => {
  get(authAxios, 'loading all print requests', 'print_requests/all_requests', controls)
}

export const apiAddPrintRequest = (authAxios, card_id, queue, controls) => {
  post(authAxios, 'adding print request', 'print_requests', { card_id, queue }, controls)
}
export const apiDownloadedPrintRequest = (authAxios, printRequestId, controls) => {
  patch(authAxios, 'marking print request as downloaded', `print_requests/${printRequestId}/downloaded`, {}, controls)
}
export const apiCompletePrintRequest = (authAxios, printRequestId, controls) => {
  patch(authAxios, 'completing print request', `print_requests/${printRequestId}/complete`, {}, controls)
}
export const apiReadyPrintRequest = (authAxios, printRequestId, controls) => {
  patch(authAxios, 'marking print request as ready', `print_requests/${printRequestId}/ready_for_pickup`, {}, controls)
}
export const apiDenyPrintRequest = (authAxios, printRequestId, denial_comment, controls) => {
  patch(authAxios, 'denying print request', `print_requests/${printRequestId}/deny`, { denial_comment }, controls)
}
export const apiDeletePrintRequest = (authAxios, printRequestId, controls) => {
  destroy(authAxios, 'deleting print request', `print_requests/${printRequestId}`, controls)
}
export const apiReopenPrintRequest = (authAxios, printRequestId, controls) => {
  patch(authAxios, 'reopening print request', `print_requests/${printRequestId}/reopen`, {}, controls)
}